export const Environment = {
  production: false,
}
